import React from 'react';

const Header = ({ title, children }) => {
    return (
        <div className='header'>
            <h1>{title}</h1>
            {children}
        </div>
    );
};

export default Header;
